import { STAGE } from 'src/constants/StageConfig';
import { getCurrentStage } from 'src/utils/StageConfigUtils';
import { ContainerAppName, setRemoteEntryFileUrlWindowAttributes } from '@amzn/employee-support-central-mfe-config';

if (getCurrentStage() === STAGE.PROD || getCurrentStage() === STAGE.ONEBOX) {
  window['FAB_URL'] = 'https://fab.myhr.a2z.com';
  window['WORKFLOW_URL'] = 'https://atoz-khonsu-workflow-rendering-app.amazon.work';
  window['KHONSU_URL'] = 'https://wui.prod.khonsu.pxt.amazon.dev';
} else {
  window['FAB_URL'] = 'https://beta.fab.myhr.a2z.com';
  window['WORKFLOW_URL'] = 'https://atoz-khonsu-workflow-rendering.integ.amazon.work';
  window['KHONSU_URL'] = 'https://wui.gamma.khonsu.pxt.amazon.dev';
}

setRemoteEntryFileUrlWindowAttributes(window, ContainerAppName.HRSC);

import('./bootstrap');

export {};
